import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaginatedQueryModel } from 'src/app/shared/models/paginatedQuery.model';
import { environment } from 'src/environments/environment';
import { CredentialModel } from '../model/credential.model';

@Injectable({
  providedIn: 'root',
})
export class CredentialsService {
  // private readonly apiRoot = 'api/credentials';

  constructor(private http: HttpClient) {}

  // API CRUD ENDPOINTS

  public getCredentials(): Observable<PaginatedQueryModel<CredentialModel> | Array<CredentialModel>> {
    return this.http.get<PaginatedQueryModel<CredentialModel> | Array<CredentialModel>>(
      `${environment.sitesBuilder.api}/api/credentials`
      // `${environment.sitesBuilder.api}/${this.apiRoot}`
    );
  }

  public postCredentials(value: CredentialModel): Observable<CredentialModel> {
    return this.http.post<CredentialModel>(`${environment.sitesBuilder.api}/api/credentials`, value);
  }

  public editCredentials(value: CredentialModel): Observable<{ credential: CredentialModel }> {
    const id = value.id;
    return this.http.patch<{ credential: CredentialModel }>(
      `${environment.sitesBuilder.api}/api/credentials/${id}`,
      value
    );
  }

  public deleteCredentials(id: number): Observable<CredentialModel> {
    return this.http.delete<CredentialModel>(`${environment.sitesBuilder.api}/api/credentials/${id}`);
  }
}
